import { useEcoAuthClient } from '@onetech/eco-auth-client-vue';

import { ApiClient } from '@/api/generated-client';
import { getStorageData } from '@/lib/local-storage';
import { TENANT_ID_STORAGE_KEY } from '@/constants/storage-keys';

export const client = new ApiClient({
  BASE: '/api',
  TOKEN: async () => {
    const ecoAuthClient = useEcoAuthClient();
    const token = await ecoAuthClient.getToken();
    return token as string;
  },
  HEADERS: async () => {
    const tenantId = getStorageData<string>(TENANT_ID_STORAGE_KEY);
    const headers: Record<string, string> = {};
    if (tenantId) {
      headers['tenant-id'] = tenantId;
    }
    return headers;
  },
});
